import { useState, useEffect} from 'react';
import DashboardLayout from '../../../../layouts/DashboardLayout';
import ModalDependence from '../../components/ModalDependence/ModalDependence';
import { DataTable } from '../../../../components/DataTable/DataTable';
import ActionsTable from '../../../../components/GenericComponents/ActionsTable';
import { dependenciesApi } from '../../api/dependencies.api';
import toast from 'react-hot-toast';
import { TOAST_SUCCESS_IDS, TOAST_ERROR_IDS } from '../../../../interaces/toast.ids.interface';
import { useDependencies } from '../../hooks/useDependencies';
import { MODE } from '../../../../interaces/mode.interface';
import { ENUM_PERMISSIONS } from '../../../../interaces/enums/enums.interface';
import { useAuth } from '../../../../context/AuthContext';
import styles from '../../styles/styles.module.css';
function Dependencies() {
  const { hasPrivilege } = useAuth();
  const [mode, setMode] = useState(MODE.CREATE);
  const [model, setModel] = useState();
  const [openModal, setOpenModal] = useState(false);
  //DataTable
  const {
    entities,
    setEntities,
    loading,
    fetchSearch,
    searchValue,
    setSearchValue,
    onClear,
    dataPagination,
    setPageData,
    pageData,
    dataFilters,
    setDataFilters,
  } = useDependencies();

  const [openModalConfirmation, setOPenModalConfirmation] = useState(false);
  const [entity, setEntity] = useState(null);

  useEffect(() => {
    fetchSearch();
  }, []);

  const handleDelete = async () => {
    try {
      await dependenciesApi.remove(entity.id);
      toast.success(TOAST_SUCCESS_IDS.RECORD_DELETED_SUCCESSFULLY, {
        id: TOAST_SUCCESS_IDS.RECORD_DELETED_SUCCESSFULLY,
      });
      setOPenModalConfirmation(false);
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.ERROR_TO_DELETE_RECORD, {
        id: TOAST_ERROR_IDS.ERROR_TO_DELETE_RECORD,
      });
    } finally {
    }
  };

  const handleEdit = (dep) => {
    setOpenModal(true);
    setMode(MODE.UPDATE);
    setModel(dep);
  };

  const columns = [
    {
      accessorKey: 'code',
      header: 'CLAVE',
    },
    {
      accessorKey: 'name',
      header: 'NOMBRE',
    },
    {
      accessorKey: 'rfc',
      header: 'RFC',
    },
    {
      accessorKey: 'organism',
      header: 'ORGANISMO',
    },
    {
      accessorKey: 'status',
      header: 'ESTADO',
      cell: ({ row }) => {
        const status = row.original.status;
        return (
          <span
            className={`
          inline-block
          rounded-[20px]
          px-3
          py-[5px]
          text-[13px]
          font-medium
          ${status ? styles.activeStatus : styles.inactiveStatus}
        `}
          >
            {status ? 'Activo' : 'Inactivo'}
          </span>
        );
      },
    },
    {
      accessorKey: 'activeUsersCount',
      header: 'NÚMERO DE USUARIOS',
      cell: ({ row }) => {
        const item = row.original;
        const number = item.activeUsersCount ?? 0;
        const status = item.status;
        return (
          <span
            className={` ${styles.numberUsers} ${status ? styles.numberUsersAndActiveStatusNumberUsers : styles.numberUsersAndInactiveStatus}`}
          >
            {number}
          </span>
        );
      },
    },
    ...(hasPrivilege(ENUM_PERMISSIONS.MOD_DEPENDENCIES_UPDATE) ||
    hasPrivilege(ENUM_PERMISSIONS.MOD_DEPENDENCIES_DELETE)
      ? [
          {
            id: 'acciones',
            header: 'ACCIONES',
            cell: ({ row }) => {
              const item = row.original;
              return (
                <ActionsTable
                  canDelete={false}
                  handleEdit={() => {
                    handleEdit(item);
                  }}
                  tienePermisoEditar={hasPrivilege(ENUM_PERMISSIONS.MOD_DEPENDENCIES_UPDATE)}
                  tienePermisoEliminar={hasPrivilege(ENUM_PERMISSIONS.MOD_DEPENDENCIES_DELETE)}
                />
              );
            },
          },
        ]
      : []),
  ];
  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="page-header-row">
          <div className="page-title-wrapper">
            <p className="page-subtitle">Administración de las dependencias.</p>
          </div>
        </div>

        <DataTable
          columns={columns}
          data={entities}
          searchPlaceholder="Buscar dependencia ..."
          pageSize={4}
          loading={loading}
          emptyMessage="No hay registros"
          onRowClick={(data) => {}}
          showSearch={true}
          showPagination={true}
          onSearch={() => fetchSearch()}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          showCreate={hasPrivilege(ENUM_PERMISSIONS.MOD_DEPENDENCIES_CREATE)}
          setOpenModal={setOpenModal}
          onClear={() => onClear()}
          showFilters={true}
          dataFilters={dataFilters}
          setDataFilters={setDataFilters}
          numberFilters={1}
          setMode={setMode}
          setModel={setModel}
          dataPagination={dataPagination}
          setPageData={setPageData}
          pageData={pageData}
        />
      </div>

      {openModal && (
        <ModalDependence
          onClose={() => setOpenModal(false)}
          mode={mode}
          model={model}
          setEntities={setEntities}
        />
      )}
    </DashboardLayout>
  );
}

export default Dependencies;
